import { useEffect, useState } from "react";
import { getCourses, deleteCourse } from "../../../services/courseApi";
import "./career.css";

export default function CareerGuideList() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await getCourses();
      setCourses(res.data.courses || []);
    } catch { console.error("Failed to load courses"); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchData(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this course?")) return;
    await deleteCourse(id);
    fetchData();
  };

  return (
    <div className="cg-page">

      {/* ══ HERO ══ */}
      <div className="cg-hero">
        <div className="cg-hero-left">
          <div className="cg-hero-icon">🎓</div>
          <div>
            <h2 className="cg-hero-title">Career Guide</h2>
            <p className="cg-hero-sub">
              {loading ? "Loading…" : `${courses.length} course${courses.length !== 1 ? "s" : ""} available`}
            </p>
          </div>
        </div>
        <div className="cg-hero-actions">
          <a href="/school-admin/career/add" className="cg-btn-add">
            + Add Course
          </a>
        </div>
      </div>

      {/* ══ TABLE ══ */}
      <div className="cg-card">
        <table className="cg-table">
          <thead>
            <tr>
              <th>Course</th>
              <th>Class</th>
              <th>Eligibility</th>
              <th>Colleges</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5">
                  <div className="cg-empty">
                    <div className="cg-empty-icon">⏳</div>
                    <strong>Loading courses…</strong>
                  </div>
                </td>
              </tr>
            ) : courses.length === 0 ? (
              <tr>
                <td colSpan="5">
                  <div className="cg-empty">
                    <div className="cg-empty-icon">🎓</div>
                    <strong>No Courses Yet</strong>
                    <p>Add your first career course to guide students.</p>
                  </div>
                </td>
              </tr>
            ) : (
              courses.map(c => (
                <tr key={c.id}>
                  <td>
                    <div className="cg-course-name">{c.name}</div>
                    {c.entrance_exam && (
                      <div className="cg-course-exam">📝 {c.entrance_exam}</div>
                    )}
                  </td>

                  <td>
                    <span className="cg-badge">{c.class_name}</span>
                  </td>

                  <td>
                    <div className="cg-eligibility">{c.eligibility || "—"}</div>
                  </td>

                  <td>
                    <span className="cg-college-count">
                      🏛️ {c.colleges.length}
                    </span>
                  </td>

                  <td>
                    <a
                      href={`/school-admin/career/edit/${c.id}`}
                      className="cg-btn-edit"
                    >
                      ✏️ Edit
                    </a>
                    <button
                      className="cg-btn-delete"
                      onClick={() => handleDelete(c.id)}
                    >
                      🗑 Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

    </div>
  );
}
